import React from 'react';
import styled from '@emotion/styled';
import { Space } from 'antd';
import { Title } from 'app/components/Typography/Title';
import ICWLogo from 'assets/images/logos/icw-logo-coloured.png';
import { SignInForm } from 'app/components/Forms/SignIn';
import { AuthContext } from 'app/providers/Authentication';
import omit from 'lodash/omit';
import { Navigate, useNavigate } from 'react-router';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Content = styled.div`
  border-radius: 4px;
  background: #fff;
  padding: 48px;
  box-shadow: 10px 10px 14px 0px rgba(180, 190, 209, 0.51);
  -webkit-box-shadow: 10px 10px 14px 0px rgba(180, 190, 209, 0.51);
  -moz-box-shadow: 10px 10px 14px 0px rgba(180, 190, 209, 0.51);
  img[alt='icw-logo'] {
    width: 180px;
    margin-bottom: 16px;
    padding-left: 16px;
  }
  .ant-space {
    width: 390px;
    form {
      width: 100%;
    }
  }
  h3 {
    text-align: center;
  }
`;
export const SignIn = () => {
  const { login, isAuthorized } = React.useContext(AuthContext);
  const navigate = useNavigate();
  if (isAuthorized) {
    return <Navigate to="/"></Navigate>;
  }
  return (
    <Container>
      <Space
        style={{ width: 550, marginBottom: 40 }}
        direction="vertical"
        align="center"
      >
        <img style={{ width: 250 }} src={ICWLogo} alt="icw-logo" />
      </Space>
      <Content style={{ maxWidth: 600 }}>
        <Title level={3}>IQC Admin</Title>
        <div>
          <SignInForm
            initialValues={{
              agreement: true
            }}
            onForgotPassword={() => {
              navigate('/reset-password');
            }}
            onFinish={(values) => {
              login?.(omit(values, 'agreement') as any);
            }}
          ></SignInForm>
        </div>
      </Content>
    </Container>
  );
};
